import { createTheme } from '@mui/material/styles';

// Spellago palette — keep MUI surfaces (modals, dialogs, fields, tables) on-brand.
const ink = '#2A2140';
const inkSoft = '#5A5070';
const tangerine = '#FF7A1A';
const grape = '#7B5BFF';
const mint = '#12B8A0';
const bubblegum = '#FF5470';
const surface = '#FFFBF3';

const theme = createTheme({
  palette: {
    primary: { main: tangerine, contrastText: '#ffffff' },
    secondary: { main: grape, contrastText: '#ffffff' },
    success: { main: mint, contrastText: '#ffffff' },
    error: { main: bubblegum, contrastText: '#ffffff' },
    text: { primary: ink, secondary: inkSoft },
    background: { paper: surface, default: '#FBEFD9' },
  },
  shape: { borderRadius: 16 },
  typography: {
    fontFamily: "'Hanken Grotesk', system-ui, -apple-system, sans-serif",
    h1: { fontFamily: "'Shantell Sans', sans-serif", fontWeight: 800 },
    h2: { fontFamily: "'Shantell Sans', sans-serif", fontWeight: 800 },
    h3: { fontFamily: "'Shantell Sans', sans-serif", fontWeight: 800 },
    h4: { fontFamily: "'Shantell Sans', sans-serif", fontWeight: 800 },
    h5: { fontFamily: "'Shantell Sans', sans-serif", fontWeight: 700 },
    h6: { fontFamily: "'Shantell Sans', sans-serif", fontWeight: 700 },
    button: { fontWeight: 800, textTransform: 'none', letterSpacing: '0.01em' },
    subtitle1: { fontWeight: 700 },
    subtitle2: { fontWeight: 700 },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: 'none' },
        rounded: { borderRadius: 24 },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 30,
          boxShadow: '0 24px 60px -20px rgba(42, 33, 64, 0.45)',
          padding: 4,
        },
      },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: {
          borderRadius: 16,
          fontWeight: 800,
          textTransform: 'none',
          paddingInline: 20,
          paddingBlock: 10,
        },
        containedPrimary: { boxShadow: '0 5px 0 #C2530A', '&:active': { transform: 'translateY(4px)', boxShadow: '0 1px 0 #C2530A' } },
        containedSecondary: { boxShadow: '0 5px 0 #4F33CC', '&:active': { transform: 'translateY(4px)', boxShadow: '0 1px 0 #4F33CC' } },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 14,
          backgroundColor: '#FFFBF3',
          fontWeight: 600,
          '& fieldset': { borderColor: 'rgba(42,33,64,0.16)', borderWidth: 2 },
          '&:hover fieldset': { borderColor: grape },
          '&.Mui-focused fieldset': { borderColor: tangerine, borderWidth: 2 },
        },
      },
    },
    MuiInputLabel: { styleOverrides: { root: { fontWeight: 700, color: inkSoft } } },
    MuiTableCell: {
      styleOverrides: {
        root: { borderColor: 'rgba(42,33,64,0.08)', fontWeight: 600, fontSize: '0.95rem' },
        head: { fontWeight: 800, color: inkSoft, textTransform: 'uppercase', letterSpacing: '0.08em', fontSize: '0.74rem' },
      },
    },
    MuiSelect: { styleOverrides: { root: { borderRadius: 14, fontWeight: 700 } } },
    MuiBackdrop: { styleOverrides: { root: { backgroundColor: 'rgba(42, 33, 64, 0.42)', backdropFilter: 'blur(3px)' } } },
  },
});

export default theme;
